(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvSingleEnumInput', drvSingleEnumInput);

    /**
     * @ngdoc directive
     * @name drvSingleEnumInput
     * @description Single enumeration (List) input
     *
     * @param {string} value - The selected enumeration
     * @param {object} field - An entity field object with properties such as 'HelpText', 'Mandatory', etc.
     */
    function drvSingleEnumInput() {
        return {
            templateUrl: 'app/fieldinput/single-enum-input.tmpl.html',
            require: 'ngModel',
            scope: {},
            controller: drvSingleEnumInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '='
            }
        };
    }

    drvSingleEnumInputCtrl.$inject = [];

    function drvSingleEnumInputCtrl() {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.showSuffix = showSuffix;
        drvCtrl.enumerationDeliminter = ',';
        Object.defineProperty(drvCtrl, 'availableEnumerations', { get: getAvailableEnumerations });

        /*
         * Get the enumerations available for the list
         *
         * @returns {array} Returns a list of enumerations which can be selected
         */
        function getAvailableEnumerations() {
            var availableEnumerations = [];

            if (!_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Enumerations))
            {
                availableEnumerations = drvCtrl.field.Enumerations.split(drvCtrl.enumerationDeliminter);
            }

            if (!_.isEqual(availableEnumerations, getAvailableEnumerations.availableEnumerations)) {
                getAvailableEnumerations.availableEnumerations = availableEnumerations;

                // If the available enumerations have been changed, it should be checked to see if the selected value is still in the list. If not, it should be set to blank.
                if (!_.isNil(drvCtrl.value) && !_.some(getAvailableEnumerations.availableEnumerations, function (availableEnumeration) { return availableEnumeration === drvCtrl.value; })) {
                    drvCtrl.value = null;
                }
            }

            return getAvailableEnumerations.availableEnumerations;
        }

        function showSuffix() {
            return !_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Suffix) && drvCtrl.field.Suffix !== '';
        }
    }
})();